/**
 * is_external=false のカードリンクを同一ウィンドウで強制的に開く
 * 外部スクリプトが window.open() などで新しいウィンドウを開くのを防ぐ
 */
window.addEventListener(
	'click',
	function ( e ) {
		const link = e.target.closest( '.card-meetup[target="_self"]' );
		if ( link && link.href ) {
			e.preventDefault();
			e.stopImmediatePropagation();
			location.href = link.href;
		}
	},
	true
);
